import { render, staticRenderFns } from "./SmallDialog.vue?vue&type=template&id=de703708&scoped=true"
import script from "./SmallDialog.vue?vue&type=script&lang=js"
export * from "./SmallDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de703708",
  null
  
)

export default component.exports